import {
	addFavorite,
	getFavorites,
	syncLocalFavorites,
	toggleFavorite,
} from '@/lib/supabase/favorites/favorites';
import { atom } from 'nanostores';

export const favoritesStore = atom< string[] >( [] );

export const loadFavorites = async ( userId: string | null ) => {
	const favorites = await getFavorites( userId );
	favoritesStore.set( favorites );
};

export const toggleFavoriteEstate = async (
	estateId: string,
	userId: string | null
) => {
	const { favorites } = await toggleFavorite( estateId, userId );
	favoritesStore.set( favorites );
};

export const addFavoriteEstate = async (
	estateId: string,
	userId: string | null
): Promise< boolean > => {
	const { added, favorites } = await addFavorite( estateId, userId );
	favoritesStore.set( favorites );
	return added;
};

export const syncFavorites = async ( userId: string ) => {
	await syncLocalFavorites( userId );
	await loadFavorites( userId );
};
